


























































































































































import _ from "@/boot/lodash";
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import Context from "@/mixins/context";
import ClientMixin from "@/mixins/clientMixin";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";
import ClientsProvider from "@/components/app/admin/clients/clientsProvider.vue";

@Component({
  components: {
    ClientsProvider
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class ClientSearch extends Mixins(
  // RequestPromises,
  Context,
  ClientMixin
) {
  //Refs

  public $refs!: {
    clientsProvider: ClientsProvider;
  };

  // Props
  @Prop({ default: "lastClients" })
  public dataScope!: string;

  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: Record<string, any>;

  @Prop({ default: null })
  public searchLabel!: string;

  @Prop({ default: 5 })
  public limit!: number;

  @Prop({ default: false })
  public onlyVerified!: boolean;

  @Prop({ default: true })
  public showGuestsToggle!: boolean;

  @Prop({ default: null })
  public onSelect!: Function;

  @Prop({ default: "" })
  public withParams!: string;

  @Prop({ default: false })
  public ignoreHistory!: boolean;

  // Data

  public isMultibrand!: boolean;
  public includeGuests = false;

  // Computed

  public get $clientsData() {
    return this.$refs.clientsProvider?.providerData();
  }

  public get $clientMethods() {
    return this.$refs.clientsProvider?.providerMethods;
  }

  public get verifiedFilter() {
    return this.onlyVerified ? { "filter[verified]": 1 } : {};
  }

  public get brandFilter() {
    return this.brandId !== UUID.ORG ? { brand_id: this.brandId } : {};
  }

  public get guestFilter() {
    return this.includeGuests ? {} : { "filter[is_guest]": false };
  }

  public get providerParams() {
    return {
      ...this.brandFilter,
      ...this.guestFilter,
      ...this.verifiedFilter,
      ...this.manualFilters,
      "filter[accounts.id|gt]": 0,
      with: this.withQueryParams
    };
  }

  public get dynamicRow() {
    if (_.isFunction(this.onSelect))
      return {
        type: "a",
        listeners: client => ({
          click: () => this.onSelect(client)
        })
      };
    return {
      type: "u-client-link",
      bind: client => ({
        client,
        clientId: client.id
      })
    };
  }

  public get showBrand() {
    return this.isAdmin && this.isMultibrand;
  }

  public get withQueryParams(): string {
    return _.compact([
      "image",
      "accounts",
      this.$store.getters.isUpmindContext && "upmind_org",
      this.showBrand && "accounts.brand",
      !_.isEmpty(this.withParams) && this.withParams
    ]).join();
  }

  // Watch

  @Watch("includeGuests")
  public includeGuestsChanged() {
    this.$nextTick(() => {
      this.$refs.clientsProvider.onPageChange(1);
    });
  }
}
